/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M21.75 3c0-1.6568-1.3431-3-3-3H5.25c-1.6568 0-3 1.3432-3 3v18c0 1.6569 1.3432 3 3 3h13.5c1.6569 0 3-1.3431 3-3V3Zm-15 3.7527a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm3.75 4.5466a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Zm-3 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm3 5.2312a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Zm-3 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
    clipRule="evenodd"
  />,
  'MenuDocumentsFilled'
);
